<template>
    <div>
        <Navbar/>
        <div class="p-4">
            <div class="d-flex mb-4 text-darker justify-content-evenly">
            <a href="#" class="text-secondary text-decoration-none">
                <i class="fas fa-search"></i> Szukaj
            </a>
            <RefreshButton :refreshing="refreshing"/>
            </div>
            <hr>
            <div class="row">
            <div class="d-lg-flex my-2 justify-content-between">
                <div>
                    <h5>
                    <router-link :to="{ name: 'UserList' }" class="text-decoration-none fw-bold">
                        LISTA UŻYTKOWNIKÓW
                    </router-link>
                    <i class="fa-solid fa-circle-arrow-right mx-3"></i>
                    </h5>
                    <h5 class="fw-bold">
                        Dodaj odbiorcę powiadomień
                    </h5>
                </div>
                <div>
                    <router-link :to="{ name: 'UserList' }" class="btn btn-primary">
                        Powrót do listy użytkowników
                    </router-link>
                </div>
            </div>
            </div>
        </div>

        <Loading
        :width="20"
        :height="20"
        :can-cancel="true"
        :is-full-page="false"
        />

        <div class="centered">
            <div v-for="recipient in recipients" :key="recipient.id" class="w-75 mb-3 centered">
                <div class="d-flex align-items-center justify-content-between">
                <div> {{ recipient.name }} <span v-if="recipient.name !== recipient.value"> -> {{ recipient.value }} </span> </div>
                <div>
                    <button class="btn btn-danger" @click="DeleteRecipient (recipient.id)">
                        Usuń
                    </button>
                    <Popper placement="right">
                        <button class=" m-1 btn btn-primary">
                            Edytuj
                        </button>
                    <template #content>
                        <form @submit.prevent="EditRecipient(recipient)">
                            <input v-model="recipient.name" type="text" class="edit-input mb-2" placeholder="Nazwa" >
                            <br>
                            <input v-model="recipient.value" id="value" type="text" class="edit-input mb-2" placeholder="Wartość" >
                            <br>
                            <button class="btn btn-primary" role="submit">
                                Edytuj
                            </button>
                        </form>
                    </template>
                    </Popper>
                </div>
                </div>
            </div>
        </div>
        <router-link to="/mailing/dodaj" class="w-50 centered">
            <button class="btn btn-primary">
                Dodaj odbiorcę powiadomień
            </button>
        </router-link>
    </div>
</template>

<script>
import Navbar from '../../components/Navbar.vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import Popper from 'vue3-popper'
import Loading from 'vue-loading-overlay'
import RefreshButton from '@/components/Layout/RefreshButton.vue'
import emitter from '@/modules/events/emitter'

export default {
    components: {
      RefreshButton,
        Navbar,
        Popper,
        Loading
    },
    data () {
        return {
            recipients: [],
            refreshing: false
        }
    },
    created () {
      emitter.on('refreshed', this.getRecipients)
    },
    mounted () {
        this.getRecipients()
    },
    methods: {
        getRecipients () {
            const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
            this.refreshing = true

            axios.get(process.env.VUE_APP_API_BASE_URL + 'NotificationRecipient', config)
                .then(response => {
                    this.recipients = response.data
                    this.isLoading = false
                })
                .catch(error => {
                    console.log(error)
                }).finally(() => this.refreshing = false)
        },
        DeleteRecipient (id) {

            // are u sure? notification
            Swal.fire({
                title: 'Jesteś pewien?',
                icon: 'warning',
                text: "Nie będzie można cofnąć tej operacji!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, usuń!'
            }).then((result) => {
                if (result.value) {
                    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

                    axios.delete(process.env.VUE_APP_API_BASE_URL + 'NotificationRecipient/' + id, config)
                        .then(response => {
                            Swal.fire('Sukces!', 'Pomyślnie usunięto odbiorcę powiadomień', 'success')
                            this.getRecipients()
                        })
                        .catch(error => {
                            console.log(error)
                        })
                }
            })
        }, EditRecipient (rec) {
            const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

            axios.put(process.env.VUE_APP_API_BASE_URL + 'NotificationRecipient/' + rec.id, {
                name: rec.name,
                value: rec.value,
                type: rec.type
            }, config)
                .then(response => {
                    Swal.fire('Sukces!', 'Pomyślnie edytowano odbiorcę powiadomień', 'success')
                    this.getRecipients()
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }
}
</script>

<style>
.centered {
    margin-left: auto;
    margin-right: auto;
}

.edit-input {
    width: 300px
}
</style>
